let _ = require('../_.js');
let $ = jQuery;

let header_is_open = false;
let _session_has_loaded = false;
let _page_fully_initialized = false;
let _pending_actions = [];

_.Login_From_Header = class Login_From_JHeader {

    // This happens pretty early in the process
    static on_ready_init() {
        this._on_ready_load_cached_visual_state();

        _.AuctionUI_Session.session_updated_handler(async function (data) {
            await _.Login_From_Header.session_updated_handler();
        });

        // Controls the 'Sign In' button at the top of the page, and the dropdown that it reveals after sign in.

        // Hook sign in button
        _.on_ui_update_once(".landproz-account-global-link-sign-in", function () {
            $(this).click(async function (e) {
                e.preventDefault();
                
                await _.Login_From_Header.handle_with_page_init('signin', async () => {
                    await _.Login_From_Header.await_for_session();
                    header_is_open = false;
                    _.Login_From_Header.update_header_is_open();
                    if (!_.Login_From_Header._is_backend_user() && !_.Login_From_Header._is_frontend_user()) {
                        _.AuctionUI_Login.login_modal();
                    }
                });
            });
        });

        _.on_ui_update_once(".landproz-account-global-link-sign-out", function () {
            $(this).click(async function (e) {
                e.preventDefault();
                await _.Login_From_Header.await_for_session();
                header_is_open = false;
                _.Login_From_Header.update_header_is_open();
                _.AuctionUI_Login.signout_clicked();
            });
        });

        _.on_ui_update_once(".landproz-account-global-link-signed-in-dropdown-link", function () {
            $(this).click(async function (e) {
                // simple menu visibility toggle
                header_is_open = !header_is_open;
                _.Login_From_Header.update_header_is_open();
            });
        });

        // Mobile My Account button
        _.on_ui_update_once(".landproz-account-global-link-signed-in-mobile-link", function () {
            $(this).click(async function (e) {
                e.preventDefault();
                await _.Login_From_Header.await_for_session();
                _.Login_From_Header.show_mobile_account_modal();
            });
        });

        // Mobile ACE Control Panel link
        _.on_ui_update_once(".link-header-ace-mobile", function () {
            $(this).click(async function (e) {
                e.preventDefault();
                await _.Login_From_Header.await_for_session();

                if (_.Login_From_Header._is_backend_user()) {
                    // Check if middle click or ctrl/cmd+click
                    const openInNewTab = e.button === 1 || (e.button === 0 && (e.ctrlKey || e.metaKey));

                    let url = _.get_ace_backend_url();

                    // Call backend to generate token
                    try {
                        let response = await _.backend_ajax('session', 'generate_frontend_token');

                        // Handle unified session response
                        let authKey = response.auto_auth_key || response.backend_auth_key;
                        if (authKey) {
                            url = url + "?auto_auth_key=" + authKey;
                        }
                    } catch (error) {
                        console.error("Error generating token", error);
                    }

                    if (openInNewTab) {
                        window.open(url, '_blank');
                    } else {
                        window.location.href = url;
                    }
                }
            });
        });


        _.on_ui_update_once($(".link-header-ace"), function () {
            $(this).click(async function (e) {
                e.preventDefault();
                await _.Login_From_Header.await_for_session();

                if (_.Login_From_Header._is_backend_user()) {
                    // Check if middle click or ctrl/cmd+click
                    const openInNewTab = e.button === 1 || (e.button === 0 && (e.ctrlKey || e.metaKey));

                    let url = _.get_ace_backend_url();

                    // Call backend to generate token
                    try {
                        // /ext_v1/session/generate_frontend_token
                        let response = await _.backend_ajax('session', 'generate_frontend_token');

                        // Handle unified session response
                        let authKey = response.auto_auth_key || response.backend_auth_key;
                        if (authKey) {
                            url = url + "?auto_auth_key=" + authKey;
                        }
                    } catch (error) {
                        console.error("Error generating token", error);
                    }

                    if (openInNewTab) {
                        window.open(url, '_blank');
                    } else {
                        window.location.href = url;
                    }

                }
            });

            // Handle middle-clicks separately with auxclick event
            $(this).on('auxclick', async function (e) {
                if (e.button === 1) { // Middle button
                    e.preventDefault();
                    console.log("ACE HEADER MIDDLE CLICKED");
                    await _.Login_From_Header.await_for_session();
                    if (_.Login_From_Header._is_backend_user()) {
                        // Handle middle-click (open in new tab)
                        try {
                            const response = await _.backend_ajax('session', 'generate_frontend_token');

                            // Handle unified session response
                            const authKey = response.auto_auth_key || response.backend_auth_key;
                            if (authKey) {
                                const baseUrl = _.get_ace_backend_url();
                                const redirectUrl = `${baseUrl}?auto_auth_key=${authKey}`;
                                window.open(redirectUrl, '_blank');
                            } else {
                                window.open(_.get_ace_backend_url(), '_blank');
                            }
                        } catch (error) {
                            console.error("Error generating token for middle-click", error);
                            window.open(_.get_ace_backend_url(), '_blank');
                        }
                    }
                }
            });
        });

        _.on_ui_update_once(".link-header-profile-settings", function () {
            $(this).click(async function (e) {
                e.preventDefault();
                
                await _.Login_From_Header.handle_with_page_init('profile-settings', async () => {
                    await _.Login_From_Header.await_for_session();
                    header_is_open = false;
                    _.Login_From_Header.update_header_is_open();
                    
                    // Close mobile menu if open
                    $(".header-new-mobile .header-menu").removeClass("header-menu-open");
                    
                    if (_.Login_From_Header._is_frontend_user()) {
                        _.User_Profile_Modal.show_settings_modal();
                    }
                });
            });
        });

    }

    static close_header() {
        header_is_open = false;
        _.Login_From_Header.update_header_is_open();
    }

    static update_header_is_open() {
        $(".landproz-account-global-dropdown-menu-desktop").set_conditional_class('visible', header_is_open);
        $(".landproz-account-global-link-signed-in-dropdown-link").set_conditional_class('active', header_is_open);
    }

    static async show_mobile_account_modal() {
        let frontend_user = _.ac_state.registrant;
        let backend_user = _.AuctionUI_Session.get_backend_user();
        let is_frontend_user = _.Login_From_Header._is_frontend_user();
        let is_backend_user = _.Login_From_Header._is_backend_user();

        let fullName;
        let email;

        if (is_backend_user) {
            fullName = backend_user.first_name + " " + backend_user.last_name;
            email = backend_user.email;
        } else {
            fullName = _.full_name(frontend_user);
            email = frontend_user.email;
        }

        let modalBody = $('<div class="mobile-account-menu"></div>');
        modalBody.append($('<div style="margin-bottom: 20px; text-align: center;"><strong>You are logged in as:</strong><br>' + fullName + ' (' + email + ')</div>'));
        
        let menuItems = $('<div class="mobile-account-menu-items"></div>');
        
        // My Auctions
        let myAuctionsBtn = $('<button class="btn btn-outline-primary btn-block mobile-account-menu-btn" style="margin-bottom: 10px; width: 100%; text-align: left;">My Auctions</button>');
        myAuctionsBtn.click(async function() {
            await _.Modal.hide();
            $(".my-auctions-link").click();
        });
        menuItems.append(myAuctionsBtn);

        // Profile Settings (only for frontend users)
        if (is_frontend_user) {
            let profileBtn = $('<button class="btn btn-outline-primary btn-block mobile-account-menu-btn" style="margin-bottom: 10px; width: 100%; text-align: left;">Profile Settings</button>');
            profileBtn.click(async function() {
                await _.Modal.hide();
                _.User_Profile_Modal.show_settings_modal();
            });
            menuItems.append(profileBtn);
        }

        // Sign Out
        let signOutBtn = $('<button class="btn btn-outline-danger btn-block mobile-account-menu-btn" style="margin-bottom: 10px; width: 100%; text-align: left;">Sign Out</button>');
        signOutBtn.click(async function() {
            await _.Modal.hide();
            _.AuctionUI_Login.signout_clicked();
        });
        menuItems.append(signOutBtn);

        modalBody.append(menuItems);

        await _.Modal.new({
            title: 'My Account',
            body: modalBody,
            body_width: 350
        });
    }

    static async await_for_session() {
        do {
            await _.sleep(100);
        } while (!_session_has_loaded);
    }
    
    static mark_page_initialized() {
        _page_fully_initialized = true;
        
        // Execute any pending actions
        while (_pending_actions.length > 0) {
            const action = _pending_actions.shift();
            setTimeout(action, 100);
        }
    }
    
    // Helper method to handle actions that require page initialization
    static async handle_with_page_init(actionName, actionCallback) {
        if (!_page_fully_initialized) {
            _.Modal.unclosable("Please wait while the page loads...");
            _pending_actions.push(async () => {
                _.Modal.hide();
                await actionCallback();
            });
            return false;
        }
        
        await actionCallback();
        return true;
    }

    static _is_frontend_user() {
        return !(!(_.ac_state.registrant));
    }

    static _is_backend_user() {
        return !(!(JSON.parse(localStorage.getItem('landproz_backend_user') || 'null')));
    }

    // Gets called from elsewhere when the session has been updated.  The session will be accessible
    // through variables _.ac_state.registrant and _.ac_state.registration.
    static session_updated_handler() {
        _session_has_loaded = true;

        let frontend_user = _.ac_state.registrant;
        let is_frontend_user = _.Login_From_Header._is_frontend_user();

        let backend_user = _.AuctionUI_Session.get_backend_user();
        let is_backend_user = _.Login_From_Header._is_backend_user();

        // console.log(is_backend_user);
        // console.log(is_frontend_user);
        // console.log(backend_user);
        // console.log(frontend_user);

        if (is_frontend_user || is_backend_user) {
            let fullName;

            if (is_backend_user) {
                fullName = backend_user.first_name + " " + backend_user.last_name;
            } else {
                fullName = _.full_name(frontend_user);
            }

            $(".my-auctions-link").show();
            $(".landproz-account-global-link-sign-in").hide();
            $(".landproz-account-global-link-signed-in").show();
            $(".landproz-account-global-link-signed-in-dropdown-link-name").text(fullName);

            // Desktop ACE Control Panel
            $(".link-header-ace").parent().set_conditional_visibility(is_backend_user);
            $(".link-header-profile-settings").parent().set_conditional_visibility(is_frontend_user);
            
            // Mobile ACE Control Panel
            $(".landproz-account-global-mobile-ace-link").set_conditional_visibility(is_backend_user);
            
            // Mobile Profile Settings
            $(".link-header-profile-settings-mobile").set_conditional_visibility(is_frontend_user);

            localStorage.setItem('landproz_signed_in', true);
            localStorage.setItem('landproz_full_name', fullName);
        } else {
            $(".landproz-account-global-link-sign-in").show();
            $(".landproz-account-global-link-signed-in").hide();
            header_is_open = false;
            _.Login_From_Header.update_header_is_open();

            localStorage.setItem('landproz_signed_in', false);
            localStorage.removeItem('landproz_full_name');
            localStorage.removeItem('landproz_backend_user');
            $(".link-header-ace").parent().hide();
            $(".link-header-profile-settings").parent().hide();
            $(".landproz-account-global-dropdown-ace-admin").remove();
            $(".landproz-account-global-mobile-ace-link").hide();
        }
    }

    // This code happens *right* away, before any data is loaded from server.  try to restore visual
    // state of signed in state from local storage.
    static _on_ready_load_cached_visual_state() {
        const cached = localStorage.getItem('landproz_signed_in');
        if (cached !== null) {
            let isSigned = cached === 'true';
            if (isSigned) {
                $(".landproz-account-global-link-sign-in").hide();
                $(".landproz-account-global-link-signed-in").show();
            }
            if (isSigned) {
                const name = localStorage.getItem('landproz_full_name');
                if (name) {
                    $(".landproz-account-global-link-signed-in-dropdown-link-name").text(name);
                }
            }
        }
    }

}